import { use } from 'react';
import { RescheduleFlowContext, type RescheduleFlowContextType } from './RescheduleFlowContext';

export const useRescheduleFlow = (): RescheduleFlowContextType => {
  const context = use(RescheduleFlowContext);
  if (context === undefined) {
    throw new Error('useRescheduleFlow must be used within a RescheduleFlowProvider');
  }
  return context;
};
